"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var framesync_1 = require("framesync");

var calc_1 = require("../calc");

var _1 = require("./");

var isValueList = function isValueList(v) {
  return Array.isArray(v);
};

var isSingleValue = function isSingleValue(v) {
  var typeOfV = typeof v;
  return typeOfV === 'string' || typeOfV === 'number';
};

var ValueReaction = function (_super) {
  __extends(ValueReaction, _super);

  function ValueReaction(props) {
    var _this = _super.call(this, props) || this;

    _this.scheduleVelocityCheck = function () {
      return framesync_1.onFrameEnd(_this.velocityCheck);
    };

    _this.velocityCheck = function () {
      if (framesync_1.currentFrameTime() !== _this.lastUpdated) {
        _this.prev = _this.current;
      }
    };

    _this.prev = _this.current = props.value || 0;

    if (isSingleValue(_this.current)) {
      _this.updateCurrent = function (v) {
        return _this.current = v;
      };

      _this.getVelocityOfCurrent = function () {
        return _this.getSingleVelocity(_this.current, _this.prev);
      };
    } else if (isValueList(_this.current)) {
      _this.updateCurrent = function (v) {
        return _this.current = v.slice();
      };

      _this.getVelocityOfCurrent = function () {
        return _this.getListVelocity();
      };
    } else {
      _this.updateCurrent = function (v) {
        _this.current = {};

        for (var key in v) {
          if (v.hasOwnProperty(key)) {
            _this.current[key] = v[key];
          }
        }
      };

      _this.getVelocityOfCurrent = function () {
        return _this.getMapVelocity();
      };
    }

    if (props.initialSubscription) _this.subscribe(props.initialSubscription);
    return _this;
  }

  ValueReaction.prototype.create = function (props) {
    return new ValueReaction(props);
  };

  ValueReaction.prototype.get = function () {
    return this.current;
  };

  ValueReaction.prototype.getVelocity = function () {
    return this.getVelocityOfCurrent();
  };

  ValueReaction.prototype.update = function (v) {
    _super.prototype.update.call(this, v);

    this.prev = this.current;
    this.updateCurrent(v);
    this.timeDelta = framesync_1.timeSinceLastFrame();
    this.lastUpdated = framesync_1.currentFrameTime();
    framesync_1.onFrameEnd(this.scheduleVelocityCheck);
  };

  ValueReaction.prototype.subscribe = function (observerCandidate) {
    var sub = _super.prototype.subscribe.call(this, observerCandidate);

    this.update(this.current);
    return sub;
  };

  ValueReaction.prototype.getSingleVelocity = function (current, prev) {
    return typeof current === 'number' && typeof prev === 'number' ? calc_1.speedPerSecond(current - prev, this.timeDelta) : calc_1.speedPerSecond(parseFloat(current) - parseFloat(prev), this.timeDelta) || 0;
  };

  ValueReaction.prototype.getListVelocity = function () {
    var _this = this;

    return this.current.map(function (c, i) {
      return _this.getSingleVelocity(c, _this.prev[i]);
    });
  };

  ValueReaction.prototype.getMapVelocity = function () {
    var velocity = {};

    for (var key in this.current) {
      if (this.current.hasOwnProperty(key)) {
        velocity[key] = this.getSingleVelocity(this.current[key], this.prev[key]);
      }
    }

    return velocity;
  };

  return ValueReaction;
}(_1.BaseMulticast);

exports.ValueReaction = ValueReaction;

exports.default = function (value, initialSubscription) {
  return new ValueReaction({
    value: value,
    initialSubscription: initialSubscription
  });
};